import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Language = 'en' | 'de' | 'es' | 'fr';

interface LanguageState {
  language: Language;
  setLanguage: (language: Language) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: 'en',
      setLanguage: (language: Language) => {
        set({ language });
        // Dynamically import i18n to avoid circular dependencies
        import('../i18n/config').then((i18nModule) => {
          i18nModule.default.changeLanguage(language);
        });
      },
    }),
    {
      name: 'waddup-language',
    }
  )
); 